export const endpoints = {
  list: (context, slug) => `/${context}/${slug}/platform-support/articles/`,
};
